<template>
  <div v-editable="blok">
    <div
      v-if="heroBannerBloks"
      class="mx-break-out h-[65vh] max-h-[1330px] min-h-[550px]"
    >
      <HeroBannerSlider :blok="heroBannerBloks" class="h-full" />
    </div>
    <AgsLazy
      v-for="(content, index) in blok.content"
      :key="content._uid"
      ssr
      :important="index <= (isMobile ? 0 : 1)"
      placeholder-ratio="16/9"
    >
      <StoryblokComponent :blok="content as any" />
    </AgsLazy>
  </div>
</template>

<script lang="ts">
import type { SbPage } from '~/cms/storyblok/types/storyblok.d.ts'

export default defineComponent({
  props: {
    blok: {
      type: Object as PropType<SbPage>,
      default: () => {},
    },
  },
  setup(props) {
    const propsRef = ref(props)
    const heroBannerBloks = computed(() =>
      Array.isArray(propsRef.value.blok.heroBanner) &&
      propsRef.value.blok.heroBanner.length > 0
        ? propsRef.value.blok.heroBanner
        : null,
    )
    const { isMobile } = useDeviceType()

    return {
      heroBannerBloks,
      isMobile,
    }
  },
})
</script>
